{
	"error": {
		"description": "Impossible de terminer.",
		"title": "Oups... Quelque chose ne s'est pas passé comme prévu."
	},
	"success": "Terminé avec succès"
}
